/**
 * Visio-backgrounds API.
 * Admin CRUD: `/visio-backgrounds`. Upload is multipart (`file` + `name`).
 */

import { apiClient } from './api-client';
import type { UpdateVisioBackgroundDto, VisioBackground } from '@/types/visio-background.types';

/** `GET /visio-backgrounds/admin` — all backgrounds including inactive. */
export const getVisioBackgroundsAdmin = async (): Promise<VisioBackground[]> => {
  const { data } = await apiClient.get<VisioBackground[]>('/visio-backgrounds/admin');
  return data;
};

/** `GET /visio-backgrounds/:id` */
export const getVisioBackground = async (id: string): Promise<VisioBackground> => {
  const { data } = await apiClient.get<VisioBackground>(`/visio-backgrounds/${id}`);
  return data;
};

/** `POST /visio-backgrounds` — multipart image upload. */
export const uploadVisioBackground = async (file: File, name: string): Promise<VisioBackground> => {
  const body = new FormData();
  body.append('file', file);
  body.append('name', name);
  const { data } = await apiClient.post<VisioBackground>('/visio-backgrounds', body);
  return data;
};

/** `PATCH /visio-backgrounds/:id` — multipart; `file` replaces the stored image when set. */
export const updateVisioBackground = async (
  id: string,
  dto: UpdateVisioBackgroundDto,
  file?: File | null,
): Promise<VisioBackground> => {
  const body = new FormData();
  if (dto.name !== undefined) body.append('name', dto.name);
  if (dto.isActive !== undefined) body.append('isActive', String(dto.isActive));
  if (file) body.append('file', file);
  const { data } = await apiClient.patch<VisioBackground>(`/visio-backgrounds/${id}`, body);
  return data;
};

/** `PATCH /visio-backgrounds/reorder` */
export const reorderVisioBackgrounds = async (ids: string[]): Promise<void> => {
  await apiClient.patch('/visio-backgrounds/reorder', { ids });
};

/** `DELETE /visio-backgrounds/:id` */
export const deleteVisioBackground = async (id: string): Promise<void> => {
  await apiClient.delete(`/visio-backgrounds/${id}`);
};
